export default "__VITE_ASSET__C4M7Tcjt__"